// @Version: 1.0.1
import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, tap } from 'rxjs';
import { IFileResult } from 'src/app/shared/components/fileupload/fileupload.model';
import * as BlobUtil from 'blob-util'
import { SpinnerService } from 'src/app/shared/services/spinner/spinner.service';
import { TRANSLATE_PATH as TRANSLATE_PATH_SHARED } from 'src/app/shared/shared.model';
import { IUploadFileData, IUploadFileMetaData } from './dialog-fileupload.model';

@Component({
    selector: 'app-dialog-fileupload',
    templateUrl: './dialog-fileupload.component.html',
    standalone: false
})
export class FieldItemDialoFileUploadComponent implements OnInit, AfterContentChecked, OnDestroy {
   public ONE_MB : number = 1024*1024;
   public TRANSLATE_PATH_SHARED: typeof TRANSLATE_PATH_SHARED = TRANSLATE_PATH_SHARED;
   public translatePath: string = "";

   private done_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public done$ = this.done_.asObservable();

   public fileData: IUploadFileData[] = []; 
   
   public filetype: string[] = []; 
   public numberFiles: number | undefined = undefined;
   public initNumberFiles: number = 1;

   @Output() isFileUploaded = new EventEmitter<boolean>();

   constructor (private cdRef: ChangeDetectorRef, public dialogRef: MatDialogRef<FieldItemDialoFileUploadComponent>, public sSpinner: SpinnerService, public sTranslate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: {metaData: IUploadFileMetaData, fileData: IUploadFileData[]}) {
      this.translatePath = data.metaData.translatePath ? data.metaData.translatePath : TRANSLATE_PATH_SHARED.DIALOG_FILEUPLOAD;
      this.fileData = data.fileData; 
   }

   ngOnInit (): void {

      this.sSpinner.start(100);

      this.done_.next(false);
      (this.sTranslate.get(this.translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_MAXNUMBEROFFILES)).pipe(
         tap((res: number) => {
            this.initNumberFiles = res ?? 1;
            this.numberFiles = this.initNumberFiles;
            this.filetype = this.data.metaData.allowedExtensions;
         })
      ).subscribe(_ => {
         this.sSpinner.close(); 
         this.done_.next(true);
      });
   }
  
   ngAfterContentChecked(): void {
      this.cdRef.detectChanges();
   }

   ngOnDestroy(): void {
      this.fileData = [];
   }

   public setNewFiles (files: IFileResult[]) {
      if (files && files.length > 0) {    
         files.forEach(elem => {
            elem.lfnr = this.fileData.length == 0 ? 1 : Math.max(...this.fileData.map(elem => elem.lfnr)) == -1 ? 1 : Math.max(...this.fileData.map(elem => elem.lfnr)) + 1; 
            this.fileData.push({...elem, url: this.createFileUrl(elem.fileExtension, elem.file)})
         });

         this.setNumberFiles(this.fileData.length); 
      }
   }

   private createFileUrl (contenttype:string, data:string): string {
      const blob = BlobUtil.base64StringToBlob(data, contenttype);
      return BlobUtil.createObjectURL(blob);
   }

   public onSaveButton (): void {
      this.isFileUploaded.emit(true);
      this.dialogRef.close(this.fileData);
   }


   public removeFile (lfnr: number): void{
      const idx = this.fileData.findIndex(elem => elem.lfnr == lfnr);
      this.fileData.splice(idx, 1);

      this.setNumberFiles(this.fileData.length); 
   }

   private setNumberFiles (length: number): void {
      if (this.numberFiles && this.initNumberFiles) this.numberFiles = this.initNumberFiles - length; 
   }

   public onDeleteClick (): void {
      this.fileData = []; 
   }
}
